import { useSelector } from 'react-redux';

import isAvailableSelector from '@/ui/flux/fiat-ramp/is-available';
import { getIsFeatureEnabled } from '@/utils/app-config';

const useFiatEnabled = () => {
  const isFeatureEnabled = getIsFeatureEnabled('fiat');
  const [isBuyAvailable, isSellAvailable] = useSelector(isAvailableSelector);

  return {
    loading: isBuyAvailable === undefined || isSellAvailable === undefined,
    enabled: isFeatureEnabled && (isBuyAvailable || isSellAvailable),
  };
};

export default useFiatEnabled;
